import { combineReducers } from 'redux';

import programsUiReducer from './resellerUiReducer';
import resellerDataReducer from './resellerDataReducer';

export default combineReducers({
  ui: programsUiReducer,
  data: resellerDataReducer,
});
